import React from "react";

export default class NoteDataType extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.data && typeof this.props.data !== 'undefined') {
      return (
        <div dangerouslySetInnerHTML={{ __html: this.props.data }} className="NoteDataType"></div>
      );
    } else {
      return (
        I18n.t('none')
      );
    };
  };
};
